import { render, staticRenderFns } from "./EdInputRadio.vue?vue&type=template&id=33b60500&"
import script from "./EdInputRadio.vue?vue&type=script&lang=js&"
export * from "./EdInputRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports